import { useSuspenseQuery } from "@tanstack/react-query";
import axios from "axios";
import { sleep } from "modules/misc";
import { TCardMaster, useCardMasters } from "./CardMasterModel";
import { apiAxiosOptions } from "modules/Drupal/Drupal";
import { isCard, TCard } from "./CardModel";
import { getCockpitConfigs } from "config";
import { DateUtil } from "utilities/date";
import { CardUtil } from "utilities";
import { TUser, useUser } from "./UserModel";
import { TRoute } from "./RouteModel";
const agh = require("agh.sprintf");

const { baseUrl } = getCockpitConfigs();

export type CardData = {};

// [ToDo] ↓は関数定義がここじゃない感。[Start]
const useRebuildSearchValues_MyShiten = (values: any) => {
  const { getUser } = useUser();
  const user = getUser();
  if ("SHITEN_CD" in values === false || !user?.shitenCD) return;
  if (Array.isArray(values["SHITEN_CD"])) {
    if (values["SHITEN_CD"].find((o: string) => o === "__MyShiten__")) {
      values["SHITEN_CD"] = values["SHITEN_CD"].filter((o: string) => o !== "__MyShiten__").concat(user.shitenCD);
    }
  } else {
    if (values["SHITEN_CD"] === "__MyShiten__") values["SHITEN_CD"] = [user.shitenCD];
  }
};
const useRebuildSearchValues_SetDateValues = (card: TCard, values: any) => {
  const { getCardMaster } = useCardMasters();
  const { showFieldsList, hasSpecialSubfields } = CardUtil;
  const cardMaster = getCardMaster(card.card_master_id);
  const allSubfieldList = cardMaster.subfields;
  const showSubfields = showFieldsList(card, "subfield", allSubfieldList);
  const month = card.month;
  if (!month) return;
  const lastYearYM = DateUtil.getLastYearYM();
  // FROMを処理
  if (month.fromY && month.fromM) {
    const fromYM = agh.sprintf("%4d%02d", month.fromY, month.fromM);
    // 次の場合だけ指定年月で再検索 : 「サブフィールドに特定の項目が表示されている場合」|| 「FROMが1年以上前の場合」
    if (hasSpecialSubfields(showSubfields) || Number(fromYM) <= Number(lastYearYM)) {
      values["NENGETU_FROM"] = fromYM;
      // FROMが有る時だけTOも処理
      if (month.toY && month.toM) {
        const toYM = agh.sprintf("%4d%02d", month.toY, month.toM);
        values["NENGETU_TO"] = toYM;
      }
    }
  }
};
const useRebuildSearchValues_manageNotIns = (values: any) => {
  if (!values.NotIns) return;
  values.NotIns.forEach((f: any) => {
    if (values[f]) {
      values[f + "__NOT_IN"] = values[f];
      delete values[f];
    }
  });
  delete values.NotIns;
  delete values.notIns;
};
export const useRebuildSearchValues = (target: TCard | TRoute, orgValues: any) => {
  let newValues = { ...orgValues };
  useRebuildSearchValues_MyShiten(newValues);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (isCard(target)) useRebuildSearchValues_SetDateValues(target, newValues);
  useRebuildSearchValues_manageNotIns(newValues);
  return newValues;
};
// [ToDo] ↑は関数定義がここじゃない感。[End]

export const useCardData = (card: TCard, searchValuesOrg: any, flag: boolean) => {
  const { getCardMaster } = useCardMasters();
  const cardMaster = getCardMaster(card.card_master_id);
  const { getUser } = useUser();
  const user = getUser();
  const { showFieldsList } = CardUtil;
  const showKamokus = showFieldsList(card, "kamoku", cardMaster.targets);

  const searchValues = useRebuildSearchValues(card, searchValuesOrg);
  const keys = {
    masterId: card.card_master_id,
    totalId: card.total_id,
    displayId: card.display_id,
    showKamokus,
    searchValues,
    flag,
  };
  const { data, refetch } = useSuspenseQuery({
    queryKey: ["fetchedCardData", { keys }],
    queryFn: () => fetchData(user, card, cardMaster, searchValues, flag, showKamokus),
  });

  return { data, refetch };
};

const fetchData = async (
  user: TUser,
  card: TCard,
  cardMaster: TCardMaster,
  searchValues: any,
  flag: boolean,
  showKamokus: string[] | undefined,
) => {
  if (!cardMaster || !flag) return null;
  // カードで__MyShiten__ が設定されているのに、個人設定で支店が設定されていない場合は error.
  if (searchValues && Array.isArray(searchValues["SHITEN_CD"]) && searchValues["SHITEN_CD"].includes("__MyShiten__")) {
    if (!user?.shitenCD) {
      return { status: "error", error: "E_MyShiten_NotExists" };
    }
  }

  const options = apiAxiosOptions();
  const result = await axios
    .get(baseUrl + cardMaster.api, {
      ...options,
      params: {
        master_type: "card_master",
        master_id: cardMaster.id,
        total_id: card.total_id,
        display_id: card.display_id,
        search_values: searchValues,
        target_ids: showKamokus ?? [],
      },
    })
    .then(await sleep(0));
  return {
    status: "success",
    data: result.data,
  };
};
